// Components
export { DrugSearch, type Drug } from './components/drug-search';
export {
  DrugInteractionsContainer,
  type DrugInteractionsContainerProps,
} from './components/drug-interactions-container';
export { InteractionResults } from './components/interaction-results';
export { InteractionCard } from './components/interaction-card';
export { SafePairsSection } from './components/safe-pairs-section';
export { ChplViewer } from './components/chpl-viewer';
export {
  DrugInteractionsPageShell,
  useScrollDirection,
  type DrugInteractionsPageShellProps,
  type InitialPanel,
  type InteractionCheckPolicy,
} from './components/drug-interactions-page-shell';
export {
  EXAMPLE_DRUG_IDS,
  isExampleSubset,
  isExactExampleSet,
} from './lib/example-drugs';
export { FreeTrialCta } from './components/free-trial-cta';
export {
  TopCheckedCombinations,
  type TopCheckedCombinationsProps,
  type CombinationDrug,
} from './components/top-checked-combinations';
export {
  InteractionPaywall,
  type PaywallVariant,
} from './components/interaction-paywall';
export { INTERACTION_PAYWALL_ID } from './lib/paywall';

// Hooks
export { useDrugInteractionsPrefetch, useInteractionCheck } from './hooks';
export { useFingerprint } from './hooks/useFingerprint';

// Types
export type {
  // ChPL extraction types
  ChplExtraction,
  ChplExtractionRow,
  // Extraction discrepancy types
  DiscrepancyType,
  ExtractionDiscrepancy,
  ComparisonResult,
  // Extraction metrics types
  LlmCallMetrics,
  DICallMetrics,
  TableStepMetrics,
  ExtractionMetrics,
  // Extraction run types
  ExtractionRunStatus,
  ExtractionRunParams,
  ExtractionRunSummary,
  // Interaction types
  InteractionSeverity,
  DrugPair,
  ChplQuote,
  ViewChplOptions,
  DrugInteraction,
  NoInteraction,
  InteractionCheckResult,
  InteractionsSummary,
  InteractionAnalysisResults,
} from './types';
export { getSeverityConfig, getPairKey } from './types';
